import React from 'react';
import { useTranslation } from 'react-i18next';
import WebsiteLayout from '../layouts/WebsiteLayout';

const Terms = () => {
  const { t, i18n } = useTranslation();

  return (
    <WebsiteLayout>
      <div className="py-5">
        {i18n.language === 'fr' ? (
          <div className="container mt-5">
            <h1>Introduction</h1>
            <p>
              Les présentes conditions générales écrites sur cette page web
              gèrent votre utilisation de notre site web,{' '}
              <strong>Solutions TransportSansGaz</strong>, accessible à{' '}
              <a
                href="https://transportsg.solutions"
                target="_blank"
                rel="noopener noreferrer"
              >
                transportsg.solutions
              </a>
              .
            </p>
            <p>
              Les présentes conditions s'appliquent intégralement et affectent
              votre utilisation de ce site web. En utilisant ce site web, vous
              acceptez toutes les conditions générales qui y sont écrites. Vous
              ne devez pas utiliser ce site web si vous n'êtes pas d'accord avec
              l'une des présentes conditions générales du site web. ("Termes",
              "Entente") est une entente survenue entre{' '}
              <strong>Solutions TransportSansGaz</strong>{' '}
              ("transportsg.solutions", "TSG Solutions", "TSG",
              "TransportSansGaz Solutions", "je", "nous" ou "on") et
              l'utilisateur du site web ("Utilisateur", "vous" ou "toi"). Cette
              entente détaille les termes et conditions générales de
              l'utilisation du site web{' '}
              <strong>Solutions TransportSansGaz</strong> ainsi que ses produits
              et services (collectivement, "site web" ou "Services").
            </p>

            <h2>Accès au site et termes généraux de l'entente</h2>
            <p>
              Vous devez avoir au moins 18 ans pour acheter nos produits. En
              utilisant ce site web et en acceptant cette entente, vous affirmez
              avoir au moins 18 ans d'âge. En créant un compte sur ce site web,
              vous êtes entièrement responsable de la sécurité de votre compte
              et de toutes les activités découlant de celui-ci. Fournir de
              fausses informations de contact peut mener à la suppression de
              votre compte sans préavis. Vous devez nous notifier immédiatement
              de toute utilisation non autorisée de votre compte ou de toute
              faille de sécurité. Nous ne pouvons pas être tenus responsables de
              tout acte ou omission de votre part, incluant, mais sans s'y
              limiter, des dommages physiques, financiers ou moraux. Nous
              pouvons suspendre ou supprimer votre compte (en tout ou en partie)
              si nous déterminons que vous avez violé une condition de cette
              entente ou que votre contenu pourrait affecter notre réputation,
              notre nom ou nos intérêts. Si nous supprimons votre compte pour
              ces raisons, vous ne pourrez pas vous réinscrire à nos Services.
              Nous nous réservons le droit de bloquer votre adresse courriel et
              votre adresse IP pour prévenir des inscriptions subséquentes.
            </p>
            <p>
              En acceptant cette entente et/ou en utilisant nos services, vous
              renoncez expressément à tout droit de tenir{' '}
              <strong>Solutions TransportSansGaz</strong>, ses administrateurs,
              actionnaires, employés, fournisseurs de services ou toute autre
              filiale de la compagnie responsables des conséquences d'une
              mauvaise utilisation de nos produits ou services.
            </p>

            <h2>À propos de l'entreprise</h2>
            <p>
              <strong>Solutions TransportSansGaz</strong> est une société
              canadienne enregistrée sous ces informations :
            </p>
            <ul>
              <li>Adresse : 2264 Av. de la Rotonde, Charny, QC G6X 2L8</li>
              <li>Numéro d'Entreprise du Québec (NEQ) : </li>
            </ul>

            <h2>Facturation et Paiement</h2>
            <p>
              Nous offrons un paiement sécurisé par carte de crédit, Paypal et
              Apple Pay. Tous les prix sont en CAD, sauf si vous utilisez le
              convertisseur de devises du site web pour convertir les devises
              disponibles. Les clients qui paient en USD ou dans toute autre
              devise verront le coût converti lors de la dernière étape de la
              commande sur le site web, en fonction du taux de conversion actuel
              de la passerelle de paiement. L'échange d'informations privées et
              sensibles est effectué par une connexion SSL sécurisée, cryptée et
              protégée par des signatures digitales. Notre site web est aussi en
              conformité avec les normes de vulnérabilité PCI afin de créer un
              environnement aussi sécurisé que possible pour nos utilisateurs.
              Si, de notre jugement, votre transaction est perçue comme un haut
              risque, nous pourrions vous demander de vérifier votre identité
              par une copie d'une pièce d'identité valide émise par un office
              gouvernemental ou une copie d'une facture de la carte utilisée
              pour la transaction. Nous nous réservons le droit de changer les
              produits et les prix des produits à tout moment sans préavis. Nous
              nous réservons aussi le droit de limiter, refuser ou rembourser
              toute commande par personne, par adresse ou par compagnie, à notre
              entière discrétion. Ces restrictions peuvent inclure des commandes
              passées sous le même compte utilisateur, la même carte de crédit
              et/ou les commandes qui utilisent les mêmes adresses de livraison
              ou de facturation. Dans une telle situation, nous tenterons
              d'abord de vous contacter par courriel et/ou téléphone selon les
              informations que vous nous aurez fournies.
            </p>

            <h2>Taxes</h2>
            <p>
              Les achats effectués par les clients canadiens sont assujettis à
              la TPS + TVQ au taux en vigueur au moment de l'achat (taux 2022 :
              14,975 %). Les clients américains n'ont pas à payer de taxes
              canadiennes. Toute taxe d'État applicable est à la charge du
              client.
            </p>

            <h2>Droits et taxes d'importation</h2>
            <p>
              Les prix des produits et services proposés n'incluent pas les
              droits de douane et d'importation perçus par le gouvernement
              américain ou tout autre gouvernement étranger, selon le cas, par
              produit, mais peuvent être modifiés en fonction de la
              réglementation en vigueur dans le pays concerné. Dans le cas
              contraire, il doit être clairement mentionné dans un devis ou sur
              la page de tarification du produit. Toute commande d'un pays autre
              que le Canada sera soumise aux lois et règlements du pays de
              destination. Lorsqu'une commande est placée et en transit, nous ne
              sommes plus responsables des délais, dommages ou saisies qui
              pourraient survenir et nous ne fournirons aucun remboursement ou
              compensation.
            </p>

            <h2>Droits de propriété intellectuelle</h2>
            <p>
              Outre le contenu dont vous êtes propriétaire, en vertu des
              présentes conditions, <strong>Solutions TransportSansGaz</strong>{' '}
              et/ou ses concédants de licence sont propriétaires de tous les
              droits de propriété intellectuelle et du matériel contenu dans ce
              site web ainsi que de toutes les communications ultérieures par
              courrier électronique ou postal. Une licence limitée vous est
              accordée uniquement pour la visualisation du matériel contenu sur
              ce site.
            </p>

            <h2>Restrictions</h2>
            <p>Il est spécifiquement interdit de :</p>
            <ul>
              <li>Publier tout matériel du site web dans tout autre média ;</li>
              <li>
                Vendre, accorder une sous-licence et/ou commercialiser de toute
                autre manière tout matériel du site web ;
              </li>
              <li>
                Présenter et/ou montrer publiquement tout matériel du site web ;
              </li>
              <li>
                Utiliser ce site web de toute manière qui est ou peut être
                dommageable pour ce site web ;
              </li>
              <li>
                Utiliser ce site web de toute manière qui aurait un impact sur
                l'accès des utilisateurs à ce site web ;
              </li>
              <li>
                Utiliser ce site web contrairement aux lois et règlements
                applicables ou de toute manière pouvant causer des dommages au
                site web, ou à toute personne ou entité commerciale ;
              </li>
              <li>
                S'engager dans toute activité d'exploration, de collecte ou
                d'extraction de données en relation avec ce site web ;
              </li>
              <li>
                Utiliser ce site web pour s'engager dans toute publicité ou
                marketing.
              </li>
            </ul>

            <h2>Contenu Utilisateur</h2>
            <p>
              Dans les présentes conditions générales du site web, "votre
              contenu" désigne tout commentaire ou document audio, vidéo, texte,
              image ou autre que vous choisissez d'afficher sur ce site web. En
              affichant votre contenu, vous accordez à{' '}
              <strong>Solutions TransportSansGaz</strong> une licence non
              exclusive, irrévocable et sous-licenciable dans le monde entier
              pour l'utiliser, le reproduire, l'adapter, le publier, le traduire
              et le distribuer dans tous les médias. Votre contenu doit vous
              appartenir et ne doit pas empiéter sur les droits d'un tiers.{' '}
              <strong>Solutions TransportSansGaz</strong> se réserve le droit de
              supprimer tout contenu de ce site web à tout moment et sans
              préavis.
            </p>

            <h2>Exactitude des informations</h2>
            <p>
              Ce site web est fourni "tel quel", avec tous les défauts, et{' '}
              <strong>Solutions TransportSansGaz</strong> n'exprime aucune
              représentation ou garantie, de quelque nature que ce soit,
              concernant ce site web ou les matériaux qui y sont contenus. Rien
              de ce qui est présent sur ce site ne doit être interprété comme un
              conseil, une recommandation ou une instruction. Des erreurs
              typographiques, inexactitudes ou omissions involontaires
              concernant les produits, la disponibilité, les prix, les frais,
              les délais de livraison, les promotions ou les offres peuvent
              apparaître sur ce site web. Nous nous réservons le droit de
              corriger toute erreur ou de mettre à jour les informations sans
              préavis.
            </p>

            <h2>Sauvegarde des données</h2>
            <p>
              Nous procédons régulièrement à des sauvegardes des données et du
              contenu du site web. Toutefois, ces sauvegardes sont à usage
              administratif seulement et ne sont en aucun cas garanties. Vous
              êtes responsable de conserver vos propres sauvegardes, et nous
              n'offrons aucune garantie ou compensation en cas de perte
              partielle ou totale de vos données.
            </p>

            <h2>Utilisations prohibées</h2>
            <p>
              En plus des autres termes de cette entente, il vous est interdit
              d'utiliser ce site web ou le contenu du site web pour :
            </p>
            <ul>
              <li>Toute utilisation illégale;</li>
              <li>
                Soliciter d'autres utilisateurs pour commettre des actes
                illégaux;
              </li>
              <li>
                Violer toute loi internationale, fédérale, provinciale ou
                étatique ou tout règlement ou ordonnance locale;
              </li>
              <li>
                Porter atteinte ou violer les droits de propriété intellectuelle
                du site web ou de ses utilisateurs;
              </li>
              <li>
                Procéder à de l'abus, du harcèlement, de la diffamation, des
                insultes, du tort, de l'intimidation ou de la discrimination
                fondée sur le sexe, l'orientation sexuelle, la religion,
                l'ethnicité, l'âge, l'origine nationale ou un handicap;
              </li>
              <li>Soumettre des informations fausses ou trompeuses;</li>
              <li>
                Publier ou transmettre des virus ou tout autre code malicieux
                pouvant compromettre les fonctionnalités du site web, les
                opérations de l'entreprise ou les informations confidentielles;
              </li>
              <li>
                Collecter ou traquer les informations personnelles d'autrui;
              </li>
              <li>
                Engager des activités de spam, phish, pharm, pretext, spider,
                crawl ou scrape;
              </li>
              <li>Toute utilisation obscène ou immorale;</li>
              <li>
                Interférer ou contourner les mesures de sécurité de ce service
                ou de tout autre site web.
              </li>
            </ul>

            <h2>Limitation de responsabilité</h2>
            <p>
              En aucun cas, <strong>Solutions TransportSansGaz</strong>, ni
              aucun de ses dirigeants, directeurs ou employés, ne pourra être
              tenu responsable des conséquences découlant de votre utilisation
              de ce site web, que cette responsabilité soit contractuelle ou
              non. <strong>Solutions TransportSansGaz</strong> ne pourra être
              tenu responsable d'aucune responsabilité indirecte, consécutive ou
              spéciale liée à votre utilisation du site.
            </p>

            <h2>Indemnisation</h2>
            <p>
              Vous indemnisez par les présentes{' '}
              <strong>Solutions TransportSansGaz</strong> et ses employés,
              administrateurs, actionnaires, sous-traitants, fournisseurs et
              partenaires, dans toute la mesure permise, contre toute
              responsabilité, coût, demande, cause d'action, dommage ou dépense
              résultant de votre violation de l'une des dispositions des
              présentes conditions.
            </p>

            <h2>Séparabilité</h2>
            <p>
              Tous les droits et restrictions contenus dans cette entente
              s'appliqueront dans la mesure où ils ne violent aucune loi en
              vigueur et pourront être ajustés pour que le reste des
              dispositions reste applicable. Si une disposition de cette entente
              est jugée illégale, invalide ou inapplicable par une autorité
              compétente, il est entendu que les autres dispositions demeureront
              en vigueur.
            </p>

            <h2>Variation des Termes</h2>
            <p>
              <strong>Solutions TransportSansGaz</strong> se réserve le droit de
              réviser les présentes conditions à tout moment et à sa convenance.
              En utilisant ce site web, vous êtes tenu de les consulter
              régulièrement.
            </p>

            <h2>Affectation</h2>
            <p>
              <strong>Solutions TransportSansGaz</strong> est autorisé à céder,
              transférer ou sous-traiter ses droits et/ou obligations en vertu
              des présentes conditions sans notification préalable. Toutefois,
              vous n'êtes pas autorisé à céder, transférer ou sous-traiter vos
              droits et/ou obligations en vertu de ces conditions.
            </p>

            <h2>Accord Complet</h2>
            <p>
              Ces conditions constituent l'accord complet entre{' '}
              <strong>Solutions TransportSansGaz</strong> et vous concernant
              votre utilisation de ce site web, et remplacent tous les accords
              et ententes antérieurs.
            </p>

            <h2>Juridiction et droits applicables</h2>
            <p>
              Les présentes conditions seront régies et interprétées
              conformément aux lois de la Province de QUÉBEC, CANADA. Vous
              acceptez la juridiction non exclusive des tribunaux d'État et
              fédéraux situés au CANADA pour la résolution de tout litige.
            </p>

            <h2>Noms commerciaux, logo et marques</h2>
            <p>
              Tous les noms de produits, marques commerciales et marques
              déposées sont la propriété de leurs propriétaires respectifs. Les
              noms d'entreprises, produits et services utilisés sur ce site web
              servent uniquement à des fins d'identification et n'impliquent
              aucune approbation.
            </p>

            <h2>Contact</h2>
            <p>
              Pour tout commentaire ou demande d’information relatif à nos
              conditions d’utilisation, veuillez contacter{' '}
              <a href="mailto:info@transportsg.solutions">
                info@transportsg.solutions
              </a>
              .
            </p>
          </div>
        ) : (
          <div className="container mt-5">
            <h1>Introduction</h1>
            <p>
              These Website Standard Terms and Conditions written on this
              webpage shall manage your use of our website,{' '}
              <strong>TransportSansGaz Solutions</strong>, accessible at{' '}
              <a
                href="https://transportsg.solutions"
                target="_blank"
                rel="noopener noreferrer"
              >
                transportsg.solutions
              </a>
              .
            </p>
            <p>
              These Terms will be applied fully and affect your use of this
              Website. By using this Website, you agreed to accept all terms and
              conditions written here. You must not use this Website if you
              disagree with any of these Website Standard Terms and Conditions.
            </p>
            <p>
              These terms and conditions (“Terms”, “Agreement”) are an agreement
              between <strong>Solutions TransportSansGaz</strong>{' '}
              (“transportsg.solutions”, “TSG Solutions”, “TSG”,
              “TransportSansGaz Solutions”, “us”, “we” or “our”) and you
              (“User”, “you” or “your”). This Agreement sets forth the general
              terms and conditions of your use of the transportsg.solutions
              website and any of its products or services (collectively,
              “Website” or “Services”).
            </p>

            <h2>Site Access and Basic Terms Agreement</h2>
            <p>
              You must be at least 18 years of age or older to be browsing
              and/or purchasing our products. By using this Website and by
              agreeing to this Agreement you warrant and represent that you are
              at least 18 years of age. If you create an account on the Website,
              you are responsible for maintaining the security of your account
              and you are fully responsible for all activities that occur under
              the account and any other actions taken in connection with it.
              Providing false contact information of any kind may result in the
              termination of your account. You must immediately notify us of any
              unauthorized uses of your account or any other breaches of
              security. We will not be liable for any acts or omissions by you,
              including any damages of any kind incurred as a result of such
              acts or omissions. We may suspend, disable, or delete your account
              (or any part thereof) if we determine that you have violated any
              provision of this Agreement or that your conduct or content would
              tend to damage our reputation and goodwill. If we delete your
              account for the foregoing reasons, you may not re-register for our
              Services. We may block your email address and Internet protocol
              address to prevent further registration.
            </p>
            <p>
              You agree to use our products and services for their intended
              purposes only. You waive without exception your right to hold{' '}
              <strong>transportsg.solutions</strong>, its employees or any of
              its subsidiaries liable in any way for the misuse of our services
              or products.
            </p>

            <h2>About the Company</h2>
            <p>
              <strong>Solutions TransportSansGaz</strong> is a registered Quebec
              Corporation under these informations:
            </p>
            <ul>
              <li>Address: 2264 Av. de la Rotonde, Charny, QC G6X 2L8</li>
              <li>Business Number (NEQ): </li>
            </ul>

            <h2>Billing &amp; Payment</h2>
            <p>
              We offer secure payment with various options via Stripe including
              VISA, Mastercard and Paypal. All prices are primarily in CAD
              unless you use the website currency converter to convert into
              available currencies. Customers paying in USD or any other
              currency will see the converted cost in USD during the final stage
              of checkout on the website based on the payment gateway’s current
              conversion rate. You shall pay all fees or charges to your account
              in accordance with the fees, charges, and billing terms in effect
              at the time a fee or charge is due and payable. Sensitive and
              private data exchange happens over an SSL secured communication
              channel and is encrypted and protected with digital signatures,
              and our Website is also in compliance with PCI vulnerability
              standards in order to create as secure an environment as possible
              for Users. If, in our judgment, your purchase constitutes a
              high-risk transaction, we will require you to provide us with a
              copy of your valid government-issued photo identification, and
              possibly a copy of a recent bank statement for the credit or debit
              card used for the purchase. We reserve the right to change
              products and product pricing at any time. We also reserve the
              right to refuse any order you place with us. We may, in our sole
              discretion, limit or cancel quantities purchased per person, per
              household or per order. These restrictions may include orders
              placed by or under the same customer account, the same credit
              card, and/or orders that use the same billing and/or shipping
              address. In the event that we make a change to or cancel an order,
              we may attempt to notify you by contacting the e-mail and/or
              billing address/phone number provided at the time the order was
              made.
            </p>

            <h2>Taxes</h2>
            <p>
              Purchases made by Canadian Customers are subject to GST+QST at the
              effective rate at the moment of purchase (2022 rate: 14.975%). US
              Customers need not pay Canadian taxes. Any applicable state taxes
              are the responsibility of the customer.
            </p>

            <h2>Import Duty/Tariff</h2>
            <p>
              The product pricing offered does not include Customs Brokerage
              &amp; Import Duty levied by the US government or any other foreign
              government as applicable per product but is subject to change as
              per the applicable country’s regulations. If otherwise, it shall
              be clearly mentioned in an estimate or product pricing page. Any
              order placed from a country other than Canada will be subject to
              your national laws and regulations. Once an order is placed and
              shipped, we are no longer responsible for any delays or seizures
              that may occur due to your country’s laws and regulations
              regarding any of the products we sell, and we will not issue any
              refund or compensation for any issues the products might encounter
              outside of Canada.
            </p>

            <h2>Intellectual Property Rights</h2>
            <p>
              Other than the content you own, under these Terms,{' '}
              <strong>transportsg.solutions</strong> and/or its licensors own
              all the intellectual property rights and materials contained in
              this Website and in all further communications by email or mail.
              You are granted a limited license only for purposes of viewing the
              material contained on this Website.
            </p>

            <h2>Restrictions</h2>
            <p>You are specifically restricted from all of the following:</p>
            <ul>
              <li>Publishing any Website material in any other media;</li>
              <li>
                Selling, sublicensing and/or otherwise commercializing any
                Website material;
              </li>
              <li>Publicly performing and/or showing any Website material;</li>
              <li>
                Using this Website in any way that is or may be damaging to this
                Website;
              </li>
              <li>
                Using this Website in any way that impacts user access to this
                Website;
              </li>
              <li>
                Using this Website contrary to applicable laws and regulations,
                or in any way that may cause harm to the Website, or to any
                person or business entity;
              </li>
              <li>
                Engaging in any data mining, data harvesting, data extracting or
                any other similar activity in relation to this Website;
              </li>
              <li>
                Using this Website to engage in any advertising or marketing.
              </li>
            </ul>
            <p>
              Certain areas of this Website are restricted from being accessed
              by you and <strong>transportsg.solutions</strong> may further
              restrict access by you to any areas of this Website, at any time,
              in its absolute discretion. Any user ID and password you may have
              for this Website are confidential and you must maintain their
              confidentiality.
            </p>

            <h2>Your Content</h2>
            <p>
              In these Website Standard Terms and Conditions, “Your Content”
              shall mean any audio, video, text, images, or other material you
              choose to display on this Website. By displaying Your Content, you
              grant <strong>transportsg.solutions</strong> a non-exclusive,
              worldwide, irrevocable, sub-licensable license to use, reproduce,
              adapt, publish, translate and distribute it in any and all media.
              Your Content must be your own and must not invade any third
              party’s rights. <strong>transportsg.solutions</strong> reserves
              the right to remove any of Your Content from this Website at any
              time without notice.
            </p>

            <h2>Accuracy of Information</h2>
            <p>
              This Website is provided “as is,” with all faults, and{' '}
              <strong>transportsg.solutions</strong> expresses no
              representations or warranties, of any kind related to this Website
              or the materials contained on this Website. Nothing contained on
              this Website shall be interpreted as advice, recommendations or
              instructions. Occasionally there may be information on the Website
              that contains typographical errors, inaccuracies, or omissions
              that may relate to pricing, product shipping charges,
              availability, promotions, and offers. We reserve the right to
              correct any errors, inaccuracies, or omissions, and to change or
              update information or cancel orders if any information on the
              Website or on any related Service is inaccurate at any time
              without prior notice (including after you have submitted your
              order). We undertake no obligation to update, amend or clarify
              information on the Website, including, without limitation, pricing
              information, except as required by law. No specified update or
              refresh date applied on the Website should be taken to indicate
              that all information on the Website or on any related Service has
              been modified or updated.
            </p>

            <h2>Backups</h2>
            <p>
              We perform regular backups of the Website and its Content;
              however, these backups are for our own administrative purposes
              only and are in no way guaranteed. You are responsible for
              maintaining your own backups of your data. We do not provide any
              compensation for lost or incomplete data in the event that backups
              do not function properly. We will do our best to ensure complete
              and accurate backups but assume no responsibility for this duty.
            </p>

            <h2>Prohibited Uses</h2>
            <p>
              In addition to other terms set forth in the Agreement, you are
              prohibited from using the Website or its Content for:
            </p>
            <ul>
              <li>Any unlawful purpose;</li>
              <li>
                Soliciting others to perform or participate in any unlawful
                acts;
              </li>
              <li>
                Violating any international, federal, provincial, or state
                regulations, rules, laws, or local ordinances;
              </li>
              <li>
                Infringing upon or violating our intellectual property rights or
                the intellectual property rights of others;
              </li>
              <li>
                Harassing, abusing, insulting, harming, defaming, slandering,
                disparaging, intimidating, or discriminating based on gender,
                sexual orientation, religion, ethnicity, race, age, national
                origin, or disability;
              </li>
              <li>Submitting false or misleading information;</li>
              <li>
                Uploading or transmitting viruses or any other type of malicious
                code that may affect the functionality or operation of the
                Service or any related website, other websites, or the Internet;
              </li>
              <li>
                Collecting or tracking the personal information of others;
              </li>
              <li>
                Engaging in spam, phish, pharm, pretext, spider, crawl, or
                scrape activities;
              </li>
              <li>Any obscene or immoral purpose; or</li>
              <li>
                Interfering with or circumventing the security features of the
                Service or any related website, other websites, or the Internet.
              </li>
            </ul>

            <h2>Limitation of Liability</h2>
            <p>
              In no event shall <strong>transportsg.solutions</strong> nor any
              of its officers, directors, and employees be held liable for
              anything arising out of or in any way connected with your use of
              this Website whether such liability is under contract.{' '}
              <strong>transportsg.solutions</strong>, including its officers,
              directors, and employees, shall not be held liable for any
              indirect, consequential, or special liability arising out of or in
              any way related to your use of this Website.
            </p>

            <h2>Indemnification</h2>
            <p>
              To the fullest extent permitted by applicable law, in no event
              will <strong>Solutions TransportSansGaz</strong>, its affiliates,
              officers, directors, employees, agents, suppliers, or licensors be
              liable to any person for (a) any indirect, incidental, special,
              punitive, cover, or consequential damages (including, without
              limitation, damages for lost profits, revenue, sales, goodwill,
              use or content, impact on business, business interruption, loss of
              anticipated savings, or loss of business opportunity) however
              caused, under any theory of liability, including, without
              limitation, contract, tort, warranty, breach of statutory duty,
              negligence or otherwise, even if{' '}
              <strong>Solutions TransportSansGaz</strong> has been advised as to
              the possibility of such damages or could have foreseen such
              damages. To the maximum extent permitted by applicable law, the
              aggregate liability of <strong>Solutions TransportSansGaz</strong>{' '}
              and its affiliates, officers, employees, agents, suppliers, and
              licensors, relating to the services will be limited to an amount
              greater of one dollar or any amounts actually paid in cash by you
              to <strong>Solutions TransportSansGaz</strong> for the prior
              one-month period preceding the event giving rise to such
              liability. The limitations and exclusions also apply if this
              remedy does not fully compensate you for any losses or fails its
              essential purpose.
            </p>

            <h2>Severability</h2>
            <p>
              All rights and restrictions contained in this Agreement may be
              exercised and shall be applicable and binding only to the extent
              that they do not violate any applicable laws and are intended to
              be limited to the extent necessary so that they will not render
              this Agreement illegal, invalid, or unenforceable. If any
              provision or portion of any provision of this Agreement is held to
              be illegal, invalid, or unenforceable by a court of competent
              jurisdiction, it is the intention of the parties that the
              remaining provisions or portions thereof shall constitute their
              agreement with respect to the subject matter hereof, and all such
              remaining provisions or portions shall remain in full force and
              effect.
            </p>

            <h2>Variation of Terms</h2>
            <p>
              <strong>transportsg.solutions.ca</strong> is permitted to revise
              these Terms at any time as it sees fit, and by using this Website
              you are expected to review these Terms on a regular basis.
            </p>

            <h2>Assignment</h2>
            <p>
              <strong>transportsg.solutions.ca</strong> is allowed to assign,
              transfer, and subcontract its rights and/or obligations under
              these Terms without any notification. However, you are not allowed
              to assign, transfer, or subcontract any of your rights and/or
              obligations under these Terms.
            </p>

            <h2>Entire Agreement</h2>
            <p>
              These Terms constitute the entire agreement between{' '}
              <strong>transportsg.solutions</strong> and you in relation to your
              use of this Website, and supersede all prior agreements and
              understandings.
            </p>

            <h2>Governing Law &amp; Jurisdiction</h2>
            <p>
              These Terms will be governed by and interpreted in accordance with
              the laws of the Province of QUEBEC, CANADA, and you submit to the
              non-exclusive jurisdiction of the state and federal courts located
              in CANADA for the resolution of any disputes.
            </p>

            <h2>Brand Names, Logo &amp; Trademarks</h2>
            <p>
              All product names, trademarks, and registered trademarks are
              property of their respective owners. All company, product, and
              service names used in this website are for identification purposes
              only. Use of these names, trademarks, and brands does not imply
              endorsement.
            </p>

            <h2>Contact</h2>
            <p>
              For any comment or information request regarding our Terms of Use,
              please contact{' '}
              <a href="mailto:info@transportsg.solutions">
                info@transportsg.solutions
              </a>
              .
            </p>
          </div>
        )}
      </div>
    </WebsiteLayout>
  );
};

export default Terms;
